export const pushDataLayerEvent = ({ event, ecommerce, ...payload }) => {
  if (typeof window === 'undefined' || !event) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  if (ecommerce) {
    window.dataLayer.push({ ecommerce: null });
  }

  window.dataLayer.push({
    event,
    ...payload,
    ...(ecommerce ? { ecommerce } : {}),
  });
};
